import { Song } from '../types';

export const songs: Song[] = [
  // Gospel retro
  {
    id: '1',
    title: 'Awesome',
    artist: 'Charles Jenkins & Fellowship Chicago',
    genre: 'Gospel retro',
    language: 'English'
  },
  {
    id: '2',
    title: 'Dès le premier jour',
    artist: 'Famille ARBOUR',
    genre: 'Gospel retro',
    language: 'French'
  },
  {
    id: '3',
    title: 'Draw Me Close to You',
    artist: 'Michael W. Smith',
    genre: 'Gospel retro',
    language: 'English'
  },
  {
    id: '4',
    title: 'For your glory',
    artist: 'Tasha Cobbs',
    genre: 'Gospel retro',
    language: 'English'
  },
  {
    id: '5',
    title: 'I know who I am',
    artist: 'Sinach',
    genre: 'Gospel retro',
    language: 'English'
  },
  {
    id: '6',
    title: 'Il fera (He Is able)',
    artist: 'Artiste non spécifié',
    genre: 'Gospel retro',
    language: 'French'
  },
  {
    id: '7',
    title: 'Je sais qui je suis en Christ (I Know Who I Am, version française)',
    artist: 'ICC Gospel Choir',
    genre: 'Gospel retro',
    language: 'French'
  },
  {
    id: '8',
    title: 'Ma famille',
    artist: 'Famille ARBOUR',
    genre: 'Gospel retro',
    language: 'French'
  },
  {
    id: '9',
    title: "Ne m'oublie pas",
    artist: 'Jude25',
    genre: 'Gospel retro',
    language: 'French'
  },
  {
    id: '10',
    title: 'Oh happy Day',
    artist: 'Sister act',
    genre: 'Gospel retro',
    language: 'English'
  },
  {
    id: '11',
    title: 'Persévère',
    artist: 'Olivier Cheuwa',
    genre: 'Gospel retro',
    language: 'French'
  },
  {
    id: '12',
    title: 'Ta valeur',
    artist: 'Joël Andres',
    genre: 'Gospel retro',
    language: 'French'
  },
  {
    id: '13',
    title: 'Tu es le chant',
    artist: 'Tabitha Lemaire',
    genre: 'Gospel retro',
    language: 'French'
  },
  {
    id: '14',
    title: 'Ville en émoi',
    artist: 'Nativité Junior',
    genre: 'Gospel retro',
    language: 'French'
  },
  
  // Gospel Moderne
  {
    id: '15',
    title: 'À genoux',
    artist: 'Deborah Lukalu',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '16',
    title: 'A la maison (choeurs)',
    artist: 'Rayan',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '17',
    title: 'Alpha and Omega',
    artist: 'Israel and New Breed',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '18',
    title: 'Believe for it',
    artist: 'CeCe Winans',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '19',
    title: 'Broken vessels',
    artist: 'Hillsong',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '20',
    title: "Can't give up now",
    artist: 'Mary Mary',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '21',
    title: 'Fire',
    artist: 'CeCe Winans',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '22',
    title: 'Goodness of God',
    artist: 'CeCe Winans',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '23',
    title: 'Gracefully broken',
    artist: 'Tasha Cobbs',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '24',
    title: 'I believe',
    artist: 'Jonathan Nelson',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '25',
    title: 'I speak Jesus',
    artist: 'Charity Gayle',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '26',
    title: 'Jireh',
    artist: 'Maverick City and Elevation Worship',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '27',
    title: 'Jour nouveau',
    artist: 'Jonathan C. Gambella',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '28',
    title: 'Là dans le feu',
    artist: 'Hillsong',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '29',
    title: 'Le nom de Jésus',
    artist: 'Jean Jean',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '30',
    title: 'Le nom de Jésus',
    artist: 'Morija',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '31',
    title: 'Love theory',
    artist: 'Kirk Franklin',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '32',
    title: 'Me voici',
    artist: 'Artiste non spécifié',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '33',
    title: 'Mon ami',
    artist: 'Morija',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '34',
    title: 'Oceans',
    artist: 'Hillsong',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '35',
    title: 'Plus de toi',
    artist: 'Sandra KOUAME',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '36',
    title: 'Promises',
    artist: 'Maverick City Music',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '37',
    title: 'Psalm 34',
    artist: 'The Brooklyn Tabernacle Choir',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '38',
    title: 'Qui tu es',
    artist: 'SOUFFLE NOUVEAU',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '39',
    title: 'Reckless love',
    artist: 'Cory Asbury',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '40',
    title: 'Say yes',
    artist: 'Michelle Williams',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '41',
    title: 'Si c\'est toi',
    artist: 'SOUFFLE NOUVEAU',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '42',
    title: 'So will I (100 billion X)',
    artist: 'Hillsong',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '43',
    title: 'Thank God I do',
    artist: 'Lauren Daigle',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '44',
    title: 'Thank you Jesus for the blood',
    artist: 'Charity Gayle',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '45',
    title: 'That\'s my King',
    artist: 'CeCe Winans',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '46',
    title: 'Touch from you',
    artist: 'Tamela Mann',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '47',
    title: 'Trust in God',
    artist: 'Elevation Worship',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '48',
    title: 'Tu frayes un chemin (FR)',
    artist: 'Sinach',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '49',
    title: 'Tu parles',
    artist: 'Mirella',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '50',
    title: 'Un seul mot',
    artist: 'SOUFFLE NOUVEAU',
    genre: 'Gospel moderne',
    language: 'French'
  },
  {
    id: '51',
    title: 'Victory belongs to jesus',
    artist: 'Todd Dulaney',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '52',
    title: 'Way maker',
    artist: 'Sinach',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '53',
    title: 'Yeshua',
    artist: 'Jesus Image',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '54',
    title: 'You made a way',
    artist: 'Travis Greene',
    genre: 'Gospel moderne',
    language: 'English'
  },
  {
    id: '55',
    title: 'You say',
    artist: 'Lauren Daigle',
    genre: 'Gospel moderne',
    language: 'English'
  },
  
  // Louanges
  {
    id: '56',
    title: 'Abrite-moi',
    artist: 'Artiste non spécifié',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '57',
    title: 'Combien Dieu est grand (Le roi dans sa beauté)',
    artist: 'Stéphane Quéry',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '58',
    title: 'Comment ne pas te louer',
    artist: 'Artiste non spécifié',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '59',
    title: 'Entends mon cœur (comment expliquer)',
    artist: 'Artiste non spécifié',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '60',
    title: 'Hosanna ! Hosanna ! (Ouvrons les portes au Dieu de gloire)',
    artist: 'Artiste non spécifié',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '61',
    title: 'Il est là (Il y a une douce harmonie)',
    artist: 'Poumy',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '62',
    title: 'Les cieux proclament',
    artist: 'Artiste non spécifié',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '63',
    title: 'Mon ancre, ma voile',
    artist: 'Artiste non spécifié',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '64',
    title: 'Mon seul abri, c\'est toi',
    artist: 'Artiste non spécifié',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '65',
    title: 'Nous voulons voir Jésus élevé',
    artist: 'Artiste non spécifié',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '66',
    title: 'O ce nom est si merveilleux',
    artist: 'Hillsong En Français',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '67',
    title: 'Ouvre les yeux de mon cœur',
    artist: 'Paul Baloche',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '68',
    title: 'Toi seul est digne',
    artist: 'Artiste non spécifié',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '69',
    title: 'Tu es là, présent parmi nous',
    artist: 'Artiste non spécifié',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '70',
    title: 'Tu es ma source',
    artist: 'Dan Luiten',
    genre: 'Louanges',
    language: 'French'
  },
  {
    id: '71',
    title: 'Veux-tu briser du péché le pouvoir',
    artist: 'Artiste non spécifié',
    genre: 'Louanges',
    language: 'French'
  },
  
  // Hymnes et Louanges
  {
    id: '72',
    title: 'Bénissons Dieu par nos cantiques (157)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '73',
    title: 'Dans ma misère (265)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '74',
    title: 'David n\'avait rien que sa fronde (567)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '75',
    title: 'Deux mains pour servir (558)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '76',
    title: 'Dieu fort et grand (18)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '77',
    title: 'Es-tu lassé (465)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '78',
    title: 'Flots mugissants (596)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '79',
    title: 'Il faut cueillir les fleurs (546)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '80',
    title: 'Je suis la lumière (561)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '81',
    title: 'Le cri de mon âme (335)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '82',
    title: 'Me voici, jeune ouvrier (566)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '83',
    title: 'Mon cœur joyeux (316)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '84',
    title: 'O toi qui donne la vie (503)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '85',
    title: 'On est bien à la maison (432)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '86',
    title: 'Près de Jésus (319)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '87',
    title: 'Quand le vol de la tempête (527)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '88',
    title: 'Quel ami fidèle et tendre (320)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '89',
    title: 'Quel repos céleste (321)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  },
  {
    id: '90',
    title: 'Qui dit au soleil (22)',
    artist: 'Hymnes et Louanges',
    genre: 'Hymnes et Louanges',
    language: 'French'
  }
];

// Sort arrays alphabetically
export const titles = [...new Set(songs.map(song => song.title))].sort();
export const genres = ["Gospel moderne", "Gospel retro", "Hymnes et Louanges", "Louanges"].sort();
export const artists = [...new Set(songs.map(song => song.artist))].sort();
export const languages = [...new Set(songs.map(song => song.language))].sort();